<template>
  <div class="p-the-j05-chat-formas">
    <div class="c-common-inner">
      <div class="p-the-j05-chat-formas__inner">
        <div ref="formGroupElement" class="p-the-j05-chat-formas__body">
          <Form
            v-slot="{ meta }"
            ref="form"
            :validation-schema="schema"
            class="p-the-j05-chat-formas__col"
            @submit="submit"
          >
          <template v-if="setMeta(meta)" />
            <label ref="textareaElement" class="p-the-j05-chat-formas__message">
              <Field
                v-slot="{ value, errorMessage, handleChange }" 
                name="message" 
                :validate-on-blur="false" 
                :validate-on-change="false"
              >
                <InputTextarea
                  ref="messageTextarea"
                  id="message"
                  :value="value"
                  @input="handleChange"
                  :error="errorMessage"
                  :add-style="{ backgroundColor: '#ffffff'}"
                  @keyup-shift-enter="doSend"
                />
               <div class="p-the-j05-chat-formas__help">
                 <p class="p-cmt">
                   全半角500文字以内
                 </p>
                 <SmallText
                   :size="11"
                   class="p-the-j05-chat-formas__message__note">
                     Enter で改行、Shift + Enter で送信できます。
                 </SmallText>
               </div>
               <ValidationErrorText v-show="errorMessage">
                 {{ errorMessage }}
               </ValidationErrorText>
              </Field>
            </label>
            <div class="p-the-j05-chat-formas__submit">
              <ButtonMain
                type="submit"
                :disabled="!meta?.valid || !meta?.dirty"
                :style="
                  !meta?.valid || !meta?.dirty
                    ? { background: '#e0e0e0' }
                    : { background: colorCode }
                "
              >
                送信
              </ButtonMain>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import { Options, Vue } from "vue-class-component";
import { Form, Field } from "vee-validate";
import * as yup from "yup";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import InputTextarea from "@/common/components/atoms/InputTextareaChat.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Options({
  components: {
    ButtonMain,
    InputTextarea,
    SmallText,
    Form,
    Field,
    ValidationErrorText
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheJ05ChatForms extends Vue {
  colorCode!: string;
  isSp = globals.isSpScreenWidth;
  message = "";
  hoverFileIconState = false;
  fileIconColor = {
    true: this.colorCode,
    false: "#333333"
  };

  meta: any = null;

  schema = yup.object({
    message: yup
      .string()
      .max(500, "500文字以内で入力してください。")
      .transform(value => value?.trim() ?? "")
      .min(1,"")
  });

  get currentFileIconColor() {
    return this.hoverFileIconState ? this.colorCode : "#333333";
  }

  setMeta(meta: any) {
    this.meta = meta;
    return true;
  }

  mounted() {
    this.initCustomColorCode();
  }

  initCustomColorCode() {
    this.fileIconColor.true = this.colorCode;
  }

  submit(values: any) {
    const messageObj = {
      date: "",
      unread: false,
      message: values.message
    };

    this.$emit("do-send", messageObj);
    this.resetFormData();
  }

  async doSend() {
    const formRef = this.$refs.form as any;
    const result = await (this.$refs.form as any).validate();
    if (!result.valid) return;

    const values = formRef.values; 

    const messageObj = {
      date: "",
      unread: false,
      message: values.message
    };

    this.$emit("do-send", messageObj);
    this.resetFormData();
  }

  resetFormData() {
    const formRef = this.$refs.form as any;
    formRef.resetForm();
    const textarea = this.$refs.messageTextarea as any;
    textarea?.resetHeight();
  }

}
</script>


<style lang="scss" scoped>
.p-the-j05-chat-formas {
  @include pc {
    padding: rem(24) 0;
  }
  @include sp {
    padding: rem(12) 0;
    margin-bottom: rem(12);
  }
  border-top: px(1) solid $common-gray300;

  &__body {
    @include pc {
      width: cal(800, 1110);
      min-width: rem(648);
    }
    margin: 0 auto;
  }

  &__reply {
    margin-bottom: rem(12);
    display: flex;
    justify-content: center;
  }

  &__col {
    display: flex;
    position: relative;
  }

  &__help {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: rem(4);    
    @include sp {
      display: block;
    }
  }
 
  &__message {
    flex-grow: 1;
    position: relative;

    &__note {
      position: static;
      width: auto;
      font-style: italic;
      text-align: right;
      @include sp {
        display: none;
      }
    }
  }

  &__submit {
    width: rem(80);
    min-width: rem(80);
    margin-left: rem(12);
  }
}

.p-cmt {
    color: #828282;
    font-size: .75rem;
    margin: 0;
    font-style: italic;
}
</style>
